import {
  Box,
  Select,
  OutlinedInput,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import _ from 'lodash';
import { sortContentByOccurrence } from '../utils/sortContent';
import { ReportedItem } from './ContentOverview';
import React, { useState } from 'react';

type ContentFiltersProps = {
  setReportedContent: (value: React.SetStateAction<ReportedItem[]>) => void;
  initialData: ReportedItem[];
};

const TimeOptions = {
  Newest: 'Newest first',
  MostReported: 'Most reported first',
};

const FormatOptions = {
  All: 'All formats',
  Comments: 'Comments',
  Posts: 'Posts',
};

export const ContentFilters = ({
  setReportedContent,
  initialData,
}: ContentFiltersProps) => {
  const [timeOption, setTimeOption] = useState(TimeOptions.Newest);
  const [formatOption, setFormatOption] = useState(FormatOptions.All);
  const onTimeOptionChange = (event: SelectChangeEvent) => {
    setTimeOption(event.target.value);
    switch (event.target.value) {
      case TimeOptions.MostReported:
        setReportedContent((data) => sortContentByOccurrence(data));
        break;
      default:
        setReportedContent((data) => _.orderBy(data, ['createdAt'], ['desc']));
    }
  };

  const onFormatOptionChange = (event: SelectChangeEvent) => {
    setFormatOption(event.target.value);
    switch (event.target.value) {
      case FormatOptions.Comments:
        timeOption === TimeOptions.Newest
          ? setReportedContent(
              _.filter(
                initialData as ReportedItem[],
                (item) => item.activityType == 'reply',
              ),
            )
          : setReportedContent(
              sortContentByOccurrence(
                _.filter(
                  initialData as ReportedItem[],
                  (item) => item.activityType == 'reply',
                ),
              ),
            );
        break;
      case FormatOptions.Posts:
        timeOption === TimeOptions.Newest
          ? setReportedContent(
              _.filter(
                initialData as ReportedItem[],
                (item) => item.activityType == 'post',
              ),
            )
          : setReportedContent(
              sortContentByOccurrence(
                _.filter(
                  initialData as ReportedItem[],
                  (item) => item.activityType == 'post',
                ),
              ),
            );
        break;
      default:
        setReportedContent((initialData as ReportedItem[]) || []);
    }
  };

  return (
    <Box className="flex gap-3">
      <Select
        value={timeOption}
        onChange={onTimeOptionChange}
        input={<OutlinedInput label="Name" />}
        className="bg-white w-[180px] h-[40px] rounded-[10px]"
      >
        {[TimeOptions.Newest, TimeOptions.MostReported].map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      <Select
        value={formatOption}
        onChange={onFormatOptionChange}
        input={<OutlinedInput label="Name" />}
        className="bg-white w-[180px] h-[40px] rounded-[10px]"
      >
        {[FormatOptions.All, FormatOptions.Comments, FormatOptions.Posts].map(
          (option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ),
        )}
      </Select>
    </Box>
  );
};
